import { Component, OnInit } from '@angular/core';
import { Preview, PreviewQuery } from '@fgb/core';
import { PreviewItemBase } from '../preview-item.base';

@Component({
  selector: 'fgbcl-preview-scorecard',
  templateUrl: './preview-scorecard.component.html',
  styleUrls: ['./preview-scorecard.component.scss', '../../preview.component.scss'],
})
export class PreviewScorecardComponent extends PreviewItemBase implements OnInit {
  scorecards: Preview[];

  constructor(private previewQuery: PreviewQuery) {
    super();
  }
  ngOnInit(): void {
    this.customOptions().responsive = { 0: { items: 1 }, 900: { items: 3 } },
      this.scorecards = this.previewQuery.getAllScoreCard();
    this.scorecards.length >= 3 ? this.setLoop(true) : this.setLoop(false)

  }

}
